<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="customerMembershipNotFound">
  <div class="modal-header">
    <h4 class="modal-title">Membership Not Found</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!(serverError || customerMembershipNotFound)">

  <div class="modal-header">
    <h4 class="modal-title">Review Membership</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="!loadingCustomerMembership">

    <table>
      <tr>
        <td class="pr-3">Membership Name:</td>
        <td>{{ customerMembership.name }}</td>
      </tr>
      <tr>
        <td class="pr-3 pt-3">Purchased By:</td>
        <td class="pt-3">
          <a routerLink="/customers/{{ customerMembership.owner_id }}/memberships-and-passes"
             target="_blank">
            {{ customerMembership.owner_first_name }} {{ customerMembership.owner_last_name }}
          </a>
        </td>
      </tr>
      <tr>
        <td class="pr-3">Purchase Date:</td>
        <td>{{ dateStringFromISO8601(customerMembership.created_at) }}</td>
      </tr>
      <tr *ngFor="let customerParsed of getCustomersParsed(); let idx = index;">
        <td *ngIf="idx === 0" class="pr-3 pt-3">Members:</td>
        <td *ngIf="idx !== 0" class="pr-3"></td>
        <td [class.pt-3]="idx === 0">
          <a *ngIf="customerParsed.id"
             routerLink="/customers/{{ customerParsed.id }}/memberships-and-passes"
             target="_blank">
            {{ customerParsed.name }}
          </a>
          <span *ngIf="!customerParsed.id">
            {{ customerParsed.name }}
          </span>
        </td>
      </tr>
    </table>

    <div class="alert alert-warning mt-4 mb-0" *ngIf="customerMembership.status === CustomerMembershipStatus.awaitingPaymentMethod">
      This membership has been paid for but is awaiting a payment method. Approving it will not activate it; it activates once a payment method is saved for the owner.
    </div>

    <div class="form-check mt-4">
      <input class="form-check-input" type="radio" id="approveInput"
             [value]="StaffApprovalAction.approve" [(ngModel)]="selectedAction">
      <label class="form-check-label" for="approveInput">
        Approve membership.
      </label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="radio" id="denyInput"
             [value]="StaffApprovalAction.deny" [(ngModel)]="selectedAction">
      <label class="form-check-label text-danger" for="denyInput">
        Deny membership.
      </label>
    </div>
    <div class="form-check" *ngIf="showHideOption">
      <input class="form-check-input" type="radio" id="hideInput"
             [value]="StaffApprovalAction.hide" [(ngModel)]="selectedAction">
      <label class="form-check-label" for="hideInput">
        Dismiss from inbox.
      </label>
    </div>

    <ng-container *ngIf="selectedAction === StaffApprovalAction.deny">
      <div class="alert alert-info mb-3 mt-3">
        Denying this membership will automatically issue a refund for the purchase and terminate the membership.
      </div>

      <div class="form-group">
        <label>Customize Customer Email Confirmation</label>
        <app-markdown-editor [(content)]="emailText" [id]="'emailText'" [shortEditor]="true"></app-markdown-editor>
      </div>
    </ng-container>

    <div class="alert alert-danger mb-0 mt-3" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-body" *ngIf="loadingCustomerMembership">
    <h3>Loading...</h3>
  </div>

  <div class="modal-footer">

    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Back
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!loadingSubmit"
            (click)="handleSave()"
            [disabled]="!validInputSelected()"
            [class.disabled]="!validInputSelected()">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>

  </div>

</ng-container>
